"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _RatingFeedback = _interopRequireDefault(require("../RatingFeedback/RatingFeedback"));

var _IconBubbleButton = _interopRequireDefault(require("../../Buttons/IconBubbleButton"));

var _IconBubble = _interopRequireDefault(require("../../IconicDisplayElements/IconBubble"));

var _ParagraphText = _interopRequireDefault(require("../../TextElements/BasicTextElements/ParagraphText"));

var _NpsScale = require("./NpsScale.styles");

var _strings = require("../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Rating component
 */

/* TODO: any fixes here may need to be replicated in Likert although there's
 * been enough divergence that that may no longer be the case. Given that this
 * has been more recently worked on, give solutions here precedence over those
 * in Likert
 */
var NpsScale = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NpsScale, _React$PureComponent);

  var _super = _createSuper(NpsScale);

  function NpsScale() {
    var _this;

    _classCallCheck(this, NpsScale);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onKeyUpHandler", function (e) {
      if (e.key === 'Enter') {
        _this.feedbackSubmitHandler();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackChangeHandler", function (e) {
      return _this.props.feedbackChangeHandler && _this.props.feedbackChangeHandler(e);
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackSubmitHandler", function () {
      return _this.props.feedbackSubmitHandler && _this.props.feedbackSubmitHandler();
    });

    _defineProperty(_assertThisInitialized(_this), "feedbackForm", function () {
      return /*#__PURE__*/_react.default.createElement(_RatingFeedback.default, {
        dataTestId: "nps-scale-rating-feedback",
        isRatingSelected: _this.props.isRatingSelected,
        isFeedbackSubmitted: _this.props.isFeedbackSubmitted,
        feedbackSubmitHandler: _this.feedbackSubmitHandler,
        feedback: _this.props.feedback,
        feedbackChangeHandler: _this.feedbackChangeHandler,
        feedbackFocus: true,
        handleKeyUp: _this.onKeyUpHandler
      });
    });

    _defineProperty(_assertThisInitialized(_this), "ratingClickHandler", function (evt) {
      var value = evt.target.value;

      _this.props.ratingClickHandler(value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (index) {
      var _this$props = _this.props,
          rating = _this$props.rating,
          isFeedbackSubmitted = _this$props.isFeedbackSubmitted;
      var k = "rating-".concat(index);
      var val = "".concat(index);
      return isFeedbackSubmitted ? /*#__PURE__*/_react.default.createElement(_IconBubble.default, {
        active: rating === parseInt(val, 10),
        colorTheme: "primaryGhost",
        className: "c-nps-scale-rating-item c-nps-scale-rating-icon",
        dataTestId: "nps-scale-rating-icon",
        key: k,
        size: "mlarge",
        text: index.toString(),
        value: val,
        disabled: true
      }) : /*#__PURE__*/_react.default.createElement(_IconBubbleButton.default, {
        active: rating === parseInt(val, 10),
        colorTheme: "primaryGhost",
        className: "c-nps-scale-rating-item c-nps-scale-rating-button",
        dataTestId: "nps-scale-rating-button",
        key: k,
        onClick: isFeedbackSubmitted ? function () {} : _this.ratingClickHandler,
        size: "mlarge",
        text: index.toString(),
        value: val
      });
    });

    return _this;
  }

  _createClass(NpsScale, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          dataTestId = _this$props2.dataTestId,
          isFeedbackSubmitted = _this$props2.isFeedbackSubmitted,
          isRatingSelected = _this$props2.isRatingSelected,
          rating = _this$props2.rating,
          question = _this$props2.question,
          feedbackChangeHandler = _this$props2.feedbackChangeHandler,
          feedbackSubmitHandler = _this$props2.feedbackSubmitHandler,
          ratingClickHandler = _this$props2.ratingClickHandler,
          props = _objectWithoutProperties(_this$props2, ["className", "dataTestId", "isFeedbackSubmitted", "isRatingSelected", "rating", "question", "feedbackChangeHandler", "feedbackSubmitHandler", "ratingClickHandler"]);

      return /*#__PURE__*/_react.default.createElement(_NpsScale.StyledNpsScale, _extends({}, props, {
        className: className,
        "data-test-id": dataTestId
      }), /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
        className: "padded-paragraph",
        dataTestId: "nps-scale-question"
      }, /*#__PURE__*/_react.default.createElement("strong", null, question)), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-nps-scale-items-wrapper"
      }, [0, 1, 2, 3, 4].map(function (i) {
        return _this2.renderOption(i);
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-nps-scale-items-wrapper"
      }, [5, 6, 7, 8, 9, 10].map(function (i) {
        return _this2.renderOption(i);
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "c-nps-scale-rating-scale-desc",
        "data-test-id": "nps-scale-rating-scale-desc"
      }, /*#__PURE__*/_react.default.createElement("span", null, _strings.npsScale.lessLikely), /*#__PURE__*/_react.default.createElement("span", null, _strings.npsScale.moreLikely)), isRatingSelected && this.feedbackForm());
    }
  }]);

  return NpsScale;
}(_react.default.PureComponent);

_defineProperty(NpsScale, "propTypes", {
  /** ===================== */

  /** COMPONENT LEVEL PROPS */

  /** ===================== */

  /** Styling hook */
  className: _propTypes.PropTypes.string,

  /** Id for testing */
  dataTestId: _propTypes.PropTypes.string.isRequired,

  /** What question are we asking? */
  question: _propTypes.PropTypes.string.isRequired,

  /** ============ */

  /** RATING PROPS */

  /** ============ */

  /** Has the rating been selected? */
  isRatingSelected: _propTypes.PropTypes.bool,

  /** Number value of rating that has been selected */
  rating: _propTypes.PropTypes.number,

  /** onClick function for the rating */
  ratingClickHandler: _propTypes.PropTypes.func.isRequired,

  /** ============== */

  /** FEEDBACK PROPS */

  /** ============== */

  /** Feedback String */
  feedback: _propTypes.PropTypes.string,

  /** onFeedback Input Change */
  feedbackChangeHandler: _propTypes.PropTypes.func.isRequired,

  /** onSubmit function for feedback */
  feedbackSubmitHandler: _propTypes.PropTypes.func.isRequired,

  /** onSubmit function for feedback */
  isFeedbackSubmitted: _propTypes.PropTypes.bool
});

_defineProperty(NpsScale, "defaultProps", {
  className: '',
  feedback: '',
  isRatingSelected: false,
  isFeedbackSubmitted: false,
  rating: undefined
});

var _default = NpsScale;
exports.default = _default;